import './plans.css'
import React, { useState } from 'react'
import tick from '../../../../assets/images/tick.png'
import active from '../../../../assets/images/active.png'

function Plans() {
    const [style, setStyle] = useState({
        img1: false, backColor1: "#FF7B00", color1: "white",
        img2: true, backColor2: "#EEEEEE", color2: "#A5A5A5",
        img3: false, backColor3: "#FF7B00", color3: "white",
        img4: false, backColor4: "#FF7B00", color4: "white",
    })

    const planHandle1 = () => {
        setStyle({
            img1: true, backColor1: "#EEEEEE", color1: "#a5a5a5",
            img2: false, backColor2: "#FF7B00", color2: "#ffffff",
            img3: false, backColor3: "#FF7B00", color3: "white",
            img4: false, backColor4: "#FF7B00", color4: "white",
        })
    }
    const planHandle2 = () => {
        setStyle({
            img1: false, backColor1: "#FF7B00", color1: "#ffffff",
            img2: true, backColor2: "#EEEEEE", color2: "#a5a5a5",
            img3: false, backColor3: "#FF7B00", color3: "white",
            img4: false, backColor4: "#FF7B00", color4: "white",
        })
    }
    const planHandle3 = () => {
        setStyle({
            img1: false, backColor1: "#FF7B00", color1: "#ffffff",
            img2: false, backColor2: "#FF7B00", color2: "#ffffff",
            img3: true, backColor3: "#EEEEEE", color3: "a5a5a5",
            img4: false, backColor4: "#FF7B00", color4: "ffffff",
        })
    }
    const planHandle4 = () => {
        setStyle({
            img1: false, backColor1: "#FF7B00", color1: "#ffffff",
            img2: false, backColor2: "#FF7B00", color2: "#ffffff",
            img3: false, backColor3: "#FF7B00", color3: "ffffff",
            img4: true, backColor4: "#EEEEEE", color4: "a5a5a5",
        })
    }
    return (
        <>
            <h3 className='dashboard-head-title'>Account Plan</h3>
            <div className='plans-parent'>
                <div className='plan-card'>
                    {style.img1 ? <img src={active} alt="" className='activeImg' /> : ''}
                    <div className='plan-card-head'>
                        <p className='head'>Plan Name 1</p>
                        <p className='text'>Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry.</p>
                    </div>
                    <div className='plan-card-body'>
                        <div>
                            <p><img src={tick} alt="" />Lorem Ipsum is simply dummy.</p>
                            <p><img src={tick} alt="" />Lorem Ipsum is dummy.</p>
                            <p><img src={tick} alt="" />Lorem is simply.</p>
                        </div>
                        <h3>$100<span>/month</span></h3>
                        <button onClick={planHandle1} className='button-primary' style={{ background: style.backColor1, color: style.color1 }}>Choose Plan</button>
                    </div>
                </div>
                <div className='plan-card'>
                    {style.img2 ? <img src={active} alt="" className='activeImg' /> : ''}
                    <div className='plan-card-head'>
                        <p className='head'>Plan Name 2</p>
                        <p className='text'>Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry.</p>
                    </div>
                    <div className='plan-card-body'>
                        <div>
                            <p><img src={tick} alt="" />Lorem Ipsum is simply dummy.</p>
                            <p><img src={tick} alt="" />Lorem Ipsum is dummy.</p>
                            <p><img src={tick} alt="" />Lorem is simply.</p>
                        </div>
                        <h3>$200<span>/month</span></h3>
                        <button onClick={planHandle2} className='button-primary' style={{ background: style.backColor2, color: style.color2 }}>Choose Plan</button>
                    </div>
                </div>
                <div className='plan-card'>
                    <div className='plan-card-head'>
                        <p className='head'>Plan Name 3</p>
                        <p className='text'>Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry.</p>
                    </div>
                    <div className='plan-card-body'>
                        <div>
                            <p><img src={tick} alt="" />Lorem Ipsum is simply dummy.</p>
                            <p><img src={tick} alt="" />Lorem Ipsum is dummy.</p>
                            <p><img src={tick} alt="" />Lorem is simply.</p>
                        </div>
                        <h3>$300<span>/month</span></h3>
                        <button onClick={planHandle3} className='button-primary' style={{ background: style.backColor3, color: style.color3 }}>Choose Plan</button>
                        {style.img3 ? <img src={active} alt="" className='activeImg' /> : ''}
                    </div>
                </div>
                <div className='plan-card'>
                    {style.img4 ? <img src={active} alt="" className='activeImg' /> : ''}
                    <div className='plan-card-head'>
                        <p className='head'>Plan Name 4</p>
                        <p className='text'>Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry.</p>
                    </div>
                    <div className='plan-card-body'>
                        <div>
                            <p><img src={tick} alt="" />Lorem Ipsum is simply dummy.</p>
                            <p><img src={tick} alt="" />Lorem Ipsum is dummy.</p>
                            <p><img src={tick} alt="" />Lorem is simply.</p>
                        </div>
                        <h3>$400<span>/month</span></h3>
                        <button onClick={planHandle4} className='button-primary' style={{ background: style.backColor4, color: style.color4 }}>Choose Plan</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Plans